(function($) {
    $(document).ready(function() {
        if ($('.fishing-day-pass-content.lite-functionality').length > 0) {
            if ( window.history.replaceState ) {
                window.history.replaceState( null, null, window.location.href );
            }

            const addToCartButton = $('.single_add_to_cart_button');

            $('#num-guests').on('change', function() {
                $('input[name="wc_bookings_field_persons"]').val($(this).val())
            })

            let bookingStartDate = $('#booking-start-date');
            bookingStartDate.change(function() {
                let date = $(this).val()
                if (!(Date.parse(date) > 0)) {
                    addToCartButton.addClass('disabled');
                    return
                }

                let dateArr = date.split('-')
                $('input[name="wc_bookings_field_start_date_year"]').val(dateArr[0])
                $('input[name="wc_bookings_field_start_date_month"]').val(dateArr[1])
                $('input[name="wc_bookings_field_start_date_day"]').val(dateArr[2])
                addToCartButton.removeClass('disabled');
            });

            addToCartButton.click(function() {
                if ($(this).hasClass('disabled')) return;
                $(this).addClass('disabled');
                $('#add-to-cart-booking-form').submit()
            })

            return;
        }

        // This functionality should be disabled on fishing pass queue page
        if ($('.queue-page.fishing-day-pass-content').length > 0) return;

        const fishingContent = $('.fishing-day-pass-content');
        if (fishingContent.length === 0) {
            return; // Abandon this hook if target does not exist
        }

        function premiumLaunched() {
            const date = new Date();
            // EST date of launch: 2022-04-18 18:00:00
            // UTC date of launch: 2022-04-18 22:00:00
            if (date.getUTCFullYear() > 2022 || date.getUTCMonth() > 3 || date.getUTCDate() > 18) return true;
            return (date.getUTCFullYear() === 2022 && date.getUTCMonth() === 3 && date.getUTCDate() === 18 && date.getUTCHours() >= 22);
        }

        function launched() {
            const date = new Date();
            // EST date of launch: 2022-01-25 18:00:00
            // UTC date of launch: 2022-01-25 23:00:00
            if (date.getUTCFullYear() > 2022 || date.getUTCMonth() > 0 || date.getUTCDate() > 25) return true;
            return (date.getUTCFullYear() === 2022 && date.getUTCMonth() === 0 && date.getUTCDate() === 25 && date.getUTCHours() >= 23);
        }

        let intervalId = window.setInterval(function(){
            if (launched()) {
                maybeEnableAddToCart();
                clearInterval(intervalId);
            }
        }, 1000);

        let calendarMemo = {};
        function getAvailability(monthYear) {
            if (monthYear in calendarMemo) {
                updateCalendar(monthYear);
                return;
            }

            $.ajax({
                url: wpApiSettings.root + wpApiSettings.namespace + '/fishing-pass/availability/'+monthYear,
                type: "GET",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
                }
            }).done(function(r) {
                if (r !== undefined && monthYear in r) {
                    calendarMemo[monthYear] = r[monthYear];
                    updateCalendar(monthYear);
                }

            });
        }

        function updateCalendar(monthYear) {
            console.log("Update calendar called");
            $('td.bookable').addClass('ui-datepicker-unselectable ui-state-disabled');
            $.each(calendarMemo[monthYear], function(date, availability) {
                availability = availability['pass'];
                if (availability === false) return;
                let ymd = date.split('-');
                let year = ymd[0];
                let month = ymd[1]-1;
                let day = ymd[2];
                let cell = $('td[data-month="'+month+'"][data-year="'+year+'"] > a').filter(function() {
                    return parseInt($(this).text()) === parseInt(day);
                });
                if (availability > 0) {
                    cell.parent().removeClass('ui-datepicker-unselectable ui-state-disabled');
                }

                if (availability >= 10) {
                    return;
                }

                if (availability <= 0) {
                    availability = "SOLD OUT";
                } else if (availability < 10) {
                    availability = "< 10 PASSES";
                }
                cell.parent().css('position', 'relative');
                cell.parent().append("<span style='position:absolute;top:50%;height:auto;width:100%;text-align:center!important;z-index:1;'>"+availability+"</span>");
            });

            $(document).trigger('availability_updated');
        }

        let currentDate = null;
        let timer;
        let runDebounce = false;
        function debounceQuery() {
            console.log('Debounce query called');
            clearTimeout(timer);
            if (!runDebounce) return;

            timer = setTimeout(function() {
                if ($('.picker > .blockUI').length <= 0) {
                    console.log('It appears that the calendar has been loaded');
                    let month = $('.ui-datepicker-title > .ui-datepicker-month').text();
                    let year = $('.ui-datepicker-title > .ui-datepicker-year').text();
                    if (month && year) {
                        currentDate = month + ' ' + year;
                        getAvailability(currentDate);
                    }

                    runDebounce = false;
                } else {
                    debounceQuery();
                }
            }, 500);
        }

        let picker_observer = new MutationObserver(function() {
            console.log('Picker observer has been triggered');
            if ($('.picker > .blockUI').length > 0) {
                runDebounce = true;
                debounceQuery()
            }
        });
        picker_observer.observe($('fieldset.wc-bookings-date-picker .picker')[0], { subtree: true, childList: true, characterData: true });

        $('.ui-datepicker-calendar td').click(function() {
            currentDate = null;
        })

        // TODO: these are temporary settings
        $('.species-slider').slick({
            slidesToShow: 3,
            infinite: true,
            responsive: [{
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    dots: true
                }
            }, {
                breakpoint: 300,
                settings: "unslick"
            }]
        });

        const bookingForm = $('form.wc-bookings-booking-form');

        // These are visible form fields for choosing a fishing day pass
        const bookingStartDate = $('input#booking-start-date');
        const numDays = $('select#num-days');
        const numGuests = $('select#num-guests');
        const addToCart = $('button[name="add-to-cart"]');

        // These are hidden form fields behind the calendar UI
        const checkInYear = $('input[name="wc_bookings_field_start_date_year"]');
        const checkInMonth = $('input[name="wc_bookings_field_start_date_month"]');
        const checkInDay = $('input[name="wc_bookings_field_start_date_day"]');
        const stayDuration = $('input[name="wc_bookings_field_duration"]');
        const numPersons = $('input[name="wc_bookings_field_persons"]');

        const handleStartDateChange = function() {
            let dateParts = bookingStartDate.val().split('-');

            let year = dateParts[0];
            let month = dateParts[1];
            let day = dateParts[2];

            checkInYear.val(year);
            checkInMonth.val(month);
            checkInDay.val(day);
            stayDuration.trigger('change');
        }
        bookingStartDate.change(handleStartDateChange)

        const handleNumDaysChange = function() {
            stayDuration.val($(this).val());
            stayDuration.trigger('change');
        }
        numDays.change(handleNumDaysChange);

        const handleNumGuestsChange = function() {
            numPersons.val($(this).val());
            numPersons.trigger('change');
        }
        numGuests.change(handleNumGuestsChange);

        /**
         * This event fires when the user clicks on a date on the calendar
         */
        const handleCalendarDateChange = function() {
            bookingStartDate.val(checkInYear.val() + '-' + checkInMonth.val() + '-' + checkInDay.val());
        }
        checkInYear.change(handleCalendarDateChange);
        checkInMonth.change(handleCalendarDateChange);
        checkInDay.change(handleCalendarDateChange);

        stayDuration.change(function() {
            numDays.val($(this).val());
        });

        function enablePremiumAccess() {
            $('.premium-access-wrapper > label').css('color', '#3f4c3d');
            $('input.premium-access').prop("disabled", false);
        }

        function disablePremiumAccess() {
            $('.premium-access-wrapper > label').css('color', '#e6e6e6');
            $('input.premium-access').prop("disabled", true);

            // Make sure that since it's disabled, it's unchecked and the change propogated
            $('#premium-access').prop('checked', false);
            $('#premium-access').change();
        }

        function updatePricingWithPremiumPass() {
            let premium_access = $('#premium-access');
            let add_premium_pass = $('#add-premium-pass');
            let new_price = 1 * $('.cost-container').data('original-cost');

            let premium_pass_price = 1 * add_premium_pass.data('unit-price');

            let guest_count = 1 * numGuests.val();
            let day_count = 1 * numDays.val();

            if (premium_access.prop('checked')) {
                new_price += premium_pass_price * guest_count * day_count;
                jQuery('.cost-container > .woocommerce-Price-amount.amount > bdi').first().contents().each(function() {
                    // nodeType 3 = a text node (this should grab just the numbers from the element)
                    if (this.nodeType != 3) return;
                    this.nodeValue = new_price.toFixed(2);
                });
            } else {
                jQuery('.cost-container > .woocommerce-Price-amount.amount > bdi').first().contents().each(function() {
                    // nodeType 3 = a text node (this should grab just the numbers from the element)
                    if (this.nodeType != 3) return;
                    this.nodeValue = new_price.toFixed(2);
                });
            }
        }
        $("#premium-access").change(function() {
            if (this.checked) {
                $('#add-premium-pass').val('true');
            } else {
                $('#add-premium-pass').val('false');
            }
            updatePricingWithPremiumPass();
        });

        let runningMaybeEnableAddToCart = false;
        /**
         * Check whether premium access is available for a given date range
         */
        const maybeEnableAddToCart = function() {
            let cost = $(document).find('.cost-container > .woocommerce-Price-amount');

            if (launched() && cost.length > 0) {
                addToCart.removeClass('disabled');
            } else {
                addToCart.addClass('disabled');
            }

            if (cost.length > 0) {
                if (runningMaybeEnableAddToCart) {
                    return;
                }

                runningMaybeEnableAddToCart = true;

                let year = checkInYear.val();
                let month = checkInMonth.val();
                let day = checkInDay.val();
                let duration = stayDuration.val();
                let guests = numPersons.val();
                let start_date = year+'-'+month+'-'+day;
                $.ajax({
                    url: wpApiSettings.root + wpApiSettings.namespace + '/premium-pass/available?start_date='+start_date+'&duration='+duration+'&guests='+guests,
                    type: "GET",
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
                    }
                }).done(function(r) {
                    if (r !== undefined && 'error' in r && r.error === false) {
                        if ('available' in r && r.available === true && premiumLaunched()) {
                            enablePremiumAccess();
                        } else {
                            disablePremiumAccess();
                        }
                    } else {
                        disablePremiumAccess();
                    }
                }).always(function() {
                    runningMaybeEnableAddToCart = false;
                    if (launched()) {
                        addToCart.removeClass('disabled');
                    }
                });
            } else {
                disablePremiumAccess();
                addToCart.addClass('disabled');
            }
        };
        maybeEnableAddToCart();

        const submitForm = function(e) {
            if (addToCart.hasClass('disabled')) {
                e.preventDefault();
                return;
            }

            bookingForm.submit();
        };

        addToCart.click(submitForm);

        const bookingCost = $('.wc-bookings-booking-cost');

        const setPriceContent = function(e) {
            let original_booking_cost = 0;
            bookingCost.find('.woocommerce-Price-amount.amount > bdi').contents().each(function() {
                // nodeType 3 = a text node (this should grab just the numbers from the element)
                if (this.nodeType != 3) return;

                original_booking_cost = this.nodeValue;
            });
            $('.cost-container').html(bookingCost.html());
            $('.cost-container').data('original-cost', original_booking_cost);
            updatePricingWithPremiumPass();
        }
        setPriceContent();
        let observer = new MutationObserver(setPriceContent);
        observer.observe(bookingCost[0], {characterData: true, childList: true});

        const costContainer = $('.cost-container');
        let ccObserver = new MutationObserver(maybeEnableAddToCart);
        ccObserver.observe(costContainer[0], {characterData: true, childList: true});
    });
})(jQuery);
